module.exports = __webpack_public_path__ + "media/application/images/2024/shapes/15-8dcd5e59fb014806fd7b11397362495e.png";